<template>
  <div class="input-wrap">
    <label for=""
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
    </label>
    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <input
      :type="type"
      :name="setKey"
      :value="value"
      :placeholder="placeholder"
      :inputmode="inputmode"
      @change="updateValue"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true, default: null },
    type: { type: String, required: true },
    setKey: { type: String, required: true },
    placeholder: { type: String, required: false },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    inputmode: { type: String, required: false },
  },
  methods: {
    updateValue(e) {
      this.$emit('input-emit', this.setKey, e.target.value)
    },
  },
}
</script>
